import type { IResponse } from "@/shared/types"
import { requestIntensity } from "@/shared/utils/axios"
import { ENERGY_AUDITS_API_URL, optionsFormData } from "../../constants"
import type { AddEnergyAuditForm, AuditContractResponse, EnergyAudit, EnergyAuditRequestParams } from "../../types"

export async function fetchNewEnergyAuditsForAuditor(params: EnergyAuditRequestParams) {
  const { data } = await requestIntensity.get(`${ENERGY_AUDITS_API_URL}/auditor/new/`, { params })
  return data as IResponse<EnergyAudit>
}

export async function fetchCurrentEnergyAuditsForAuditor(params: EnergyAuditRequestParams) {
  const { data } = await requestIntensity.get(`${ENERGY_AUDITS_API_URL}/auditor/current/`, { params })
  return data as IResponse<EnergyAudit>
}

export async function addEnergyAudit(payload: AddEnergyAuditForm) {
  const { data } = await requestIntensity.post(`${ENERGY_AUDITS_API_URL}/`, payload, optionsFormData)
  return data as AuditContractResponse
}
